module.exports = __webpack_public_path__ + "img/grid-item-rivoneed.0a229573.webp";